import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f3880062")

_pushScopeId("data-v-f3880062")
const _hoisted_1 = { class: "shell padding30px height90per" }
const _hoisted_2 = { class: "float-right" }
const _hoisted_3 = { class: "detail-label detail-label-title" }
const _hoisted_4 = { class: "detail-label" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_8 = { class: "detail-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list = _resolveComponent("list")
  const _component_user_dialog = _resolveComponent("user-dialog")
  const _component_billing_information = _resolveComponent("billing-information")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_cus_button, {
        type: "default",
        onClick: _ctx.getBillingInfo
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.OrderBillingInformation), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.officeInfo.Active === '0')
        ? (_openBlock(), _createBlock(_component_cus_button, {
            key: 0,
            class: "margin-left10px",
            onClick: _ctx.activeUser
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.RDeviceListTanleActive), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_cus_button, {
        class: "margin-left10px",
        type: "blue",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowCnfDialog = true))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.NavInHtmlMenuSet), 1)
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infoKey, (item) => {
      return (_openBlock(), _createBlock("div", {
        key: item.key
      }, [
        _createVNode("label", _hoisted_3, _toDisplayString(item.label) + ":", 1),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.officeInfo[item.key]?_ctx.officeInfo[item.key]:'--'), 1)
      ]))
    }), 128)),
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createVNode("b", _hoisted_8, _toDisplayString(_ctx.$wordList.OrderDevice), 1),
    _createVNode(_component_list, {
      headers: _ctx.deviceHeaders,
      showCheck: false,
      action: false,
      requestData: _ctx.devRequestData
    }, null, 8, ["headers", "requestData"]),
    (_ctx.isShowCnfDialog)
      ? (_openBlock(), _createBlock(_component_user_dialog, {
          key: 0,
          id: _ctx.id,
          expireTime: _ctx.officeInfo.ExpireTime,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowCnfDialog=false)),
          onSuccess: _ctx.getOfficeInfo
        }, null, 8, ["id", "expireTime", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.isShowBillInfo)
      ? (_openBlock(), _createBlock(_component_billing_information, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowBillInfo=false)),
          "user-id": _ctx.id
        }, null, 8, ["user-id"]))
      : _createCommentVNode("", true)
  ]))
})